module.exports = __webpack_public_path__ + "img/faming17.b890e817.png";